import { Card, CardActionArea, CardMedia, CardContent, Typography, Grid, Box } from '@mui/material';
import machineDefaultImage from '../../images/machineImageEmpty.svg';
import { entityGridPhotoUrl } from '../entityImage/entityImageConfig';
import { plainTextFromRichText } from '../../utils/richText';
import { useNavigate } from 'react-router-dom';
import Skeleton from '@mui/material/Skeleton';
import React, { useCallback } from 'react';
import '../../css/risques/risqueCardView.css';
import OrderMoveButtons from '../listOrder/OrderMoveButtons';

const ArticleFolderGridData = React.memo(({ index, style, data }) => {

    const { articleFolders, columns, filteredArticleFoldersCount, canReorder, onMove } = data;
    const navigate = useNavigate();
    const startIndex = index * columns;
    const endIndex = Math.min(startIndex + columns, filteredArticleFoldersCount);

    const handleArticleFolderClick = useCallback((articleFolderId) => navigate(`dossiers_articles_details/${articleFolderId}`), [navigate]);

    return (
        <Grid style={style} key={index} container spacing={2}>
            {Array.from({ length: endIndex - startIndex })?.map((_, idx) => {
                const articleFolderIndex = startIndex + idx;
                const articleFolder = articleFolders[articleFolderIndex];
                const imageUrl = articleFolder
                    ? entityGridPhotoUrl(articleFolder, 'articleFolder', { size: 'small' })
                    : '';

                return (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={articleFolder ? articleFolder.id : `skeleton-${articleFolderIndex}`}>
                        <Card className='risques_gridview_card' sx={{ position: 'relative' }}>
                            {canReorder && articleFolder && (
                                <Box sx={{ position: 'absolute', top: 4, right: 4, zIndex: 2, backgroundColor: 'rgba(255,255,255,0.92)', borderRadius: '8px' }}>
                                    <OrderMoveButtons
                                        disableUp={articleFolderIndex <= 0}
                                        disableDown={articleFolderIndex >= filteredArticleFoldersCount - 1}
                                        onMove={(direction) => onMove(articleFolder.id, direction)}
                                    />
                                </Box>
                            )}
                            <CardActionArea onClick={articleFolder ? () => handleArticleFolderClick(articleFolder?.id) : undefined}>
                                {articleFolder ? (
                                    <>
                                        {/* Blurred Background Image */}
                                        <CardMedia
                                            component="img"
                                            image={imageUrl || machineDefaultImage}
                                            alt={`${articleFolder?.name} background`}
                                            style={{
                                                position: 'absolute',
                                                width: '100%',
                                                height: '192px',
                                                top: 0,
                                                left: 0,
                                                zIndex: 0,
                                                objectFit: 'cover',
                                                filter: 'blur(10px)',
                                            }}
                                            loading="lazy"
                                            decoding="async"
                                        />

                                        {/* Main Image Over Content */}
                                        <CardMedia
                                            component="img"
                                            height="192"
                                            style={{
                                                position: 'relative',
                                                objectFit: imageUrl ? 'contain' : 'cover',
                                                zIndex: 1
                                            }}
                                            image={imageUrl || machineDefaultImage}
                                            alt={articleFolder?.name}
                                            loading="lazy"
                                            decoding="async"
                                        />
                                        <CardContent className='risques_gridview_card_CardContent'>
                                            <Typography className='risques_gridview_risque_name' component="div">{articleFolder?.title}</Typography>
                                            <Typography className='risques_gridview_risque_adress' component="div">{plainTextFromRichText(articleFolder?.description) || '--'}</Typography>
                                        </CardContent>
                                    </>
                                ) : (
                                    <>
                                        <Skeleton variant="rectangular" height={192} />
                                        <CardContent className='machines_gridview_card_CardContent'>
                                            <Skeleton variant="text" />
                                            <Skeleton variant="text" />
                                        </CardContent>
                                    </>
                                )}
                            </CardActionArea>
                        </Card>
                    </Grid>
                );
            })}
        </Grid>
    );
});

export default ArticleFolderGridData;